<template>
  <TableLayout>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <el-button type="primary" :loading="isWorking.export" @click="exportExcel">导出明细</el-button>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="openid" label="用户" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="code" label="订单编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="payDate" label="支付时间" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="money" label="支付金额" width="80px" align="center"></el-table-column>
        <el-table-column prop="refundDate" label="退款时间" width="150px" align="center"></el-table-column>
        <el-table-column prop="refundMoney" label="退款金额" width="80px" align="center"></el-table-column>
        <el-table-column prop="closeMoney" label="结算金额" width="80px" align="center"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'

export default {
  name: 'BaseParam',
  extends: BaseTable,
  components: { TableLayout, Pagination },

  data () {
    return {
      // 搜索
      searchForm: {
        endDate: '',
        startDate: '',
        type: ''
      }
    }
  },
  created () {
    this.config({
      module: '系统基础配置表',
      api: '/business/billDetail',
    })
  },
  methods: {
    reload(target) {
      this.searchForm = target
      this.tableData.pagination.pageIndex = 1
      this.search()
    }
  },
}
</script>
